import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconBell, IconPlay, IconHome, IconCompass, IconUser } from './Icons';
import { useAuth } from '../core/firebase/useAuth';
import { useAuthModal } from '../core/AuthModalContext';
import { useLang } from '../core/i18n';

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { showAuthModal } = useAuthModal();
  const { t } = useLang();

  const tabs = [
    { path: '/notifications', Icon: IconBell,    labelKey: 'notifications', protected: true  },
    { path: '/videos',        Icon: IconPlay,    labelKey: 'videos',        protected: false },
    { path: '/',              Icon: IconHome,    labelKey: 'home',          protected: false },
    { path: '/explore',       Icon: IconCompass, labelKey: 'explore',       protected: false },
    { path: '/profile',       Icon: IconUser,    labelKey: 'profile',       protected: false },
  ];

  const handleTab = (tab) => {
    if (tab.protected && !user) showAuthModal();
    else navigate(tab.path);
  };

  return (
    <nav style={{
      ...styles.nav,
      background: 'var(--bg-primary)',
      borderTop: '1px solid var(--border-color)',
      boxShadow: '0 -2px 12px rgba(0,0,0,0.06)',
    }}>
      {tabs.map((tab) => {
        const active = pathname === tab.path;
        return (
          <button
            key={tab.path}
            className="bottom-tab-btn"
            style={{
              ...styles.tab,
              color: active ? '#6366f1' : 'var(--text-secondary)',
            }}
            onClick={() => handleTab(tab)}
          >
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {active && <div style={{...styles.activeGlow, background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(139, 92, 246, 0.2) 100%)'}} />}
              <tab.Icon size={24} color={active ? '#6366f1' : 'currentColor'} />
            </div>
            <span style={{ ...styles.label, color: active ? '#6366f1' : 'var(--text-secondary)', fontWeight: active ? 700 : 500 }}>
              {t[tab.labelKey] || tab.labelKey}
            </span>
            {active && <div className="tab-dot" style={{background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)'}} />}
          </button>
        );
      })}
    </nav>
  );
}

const styles = {
  nav: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    background: '#FFFFFF',
    borderTop: '1px solid #E4E6EA',
    boxShadow: '0 -2px 12px rgba(0,0,0,0.06)',
    padding: '6px 0 14px',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 100,
  },
  tab: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 3,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px 14px',
    minWidth: 52,
  },
  label: {
    fontSize: 10.5,
    letterSpacing: '0.1px',
  },
  activeGlow: {
    position: 'absolute',
    width: 38,
    height: 38,
    borderRadius: '50%',
    background: 'rgba(24, 119, 242, 0.1)',
    zIndex: -1,
  },
};
